import { Component, Fragment } from 'react';

import SideBarAndNavBar from 'member/components/SideBarAndNavBar'
import {connect} from "react-redux"
import {isJobApp} from "shared/apps"
import JobNavBar from "member/components/JobPost/JobNavBar"
import Footer from "./components/Footer"
import JobFooter from "member/components/JobPost/JobFooter"

class MemberIndex extends Component {
  render() {
    const jobApp = isJobApp()
    return (
      <Fragment>
        {
          jobApp &&
            <JobNavBar />
        }
        {
          !jobApp && <SideBarAndNavBar />
        }
        <div className='main-body'>
          {this.props.children}
        </div>
        {
          jobApp &&
          <JobFooter />
        }
        {
          !jobApp && <Footer />
        }
      </Fragment>
    )
  }
}

function mapStateToProps(state) {
  const { users } = state;

  return {
    current_user: users.user
  }
}

export default connect(mapStateToProps, null)(MemberIndex)
